module.exports = __webpack_public_path__ + "img/b85e408.jpg";